import * as React from 'react';
import ConfirmationModal from 'components/Common/confirmationModal';
import './openCycleConfirmationModal.scss';

export interface IOpenCycleConfirmationModalProps {
    isModalOpen: boolean;
    closeModal: () => void;
    onNotifyManagersClick: () => void;
}

export class OpenCycleConfirmationModal extends
    React.Component<IOpenCycleConfirmationModalProps> {
    constructor(props: IOpenCycleConfirmationModalProps) {
        super(props);
        this._closeOpenCycleModal = this._closeOpenCycleModal.bind(this);
        this._notifyManagersClick = this._notifyManagersClick.bind(this);
        this._cancelOpenCycleModal = this._cancelOpenCycleModal.bind(this);
    }

    render(): React.ReactNode {
        if (!this.props.isModalOpen) {
            return null;
        }

        return (
            <ConfirmationModal
                cancelMessage="Cancel"
                className="open-cycle-modal"
                confirmMessage="Yes, Open Cycle"
                message={this.renderOpenCycleModalBody()}
                onCancel={this._cancelOpenCycleModal}
                onClose={this._closeOpenCycleModal}
                onConfirm={this._notifyManagersClick}
                title="Ready to open your cycle to managers?"
            />
        );
    }

    renderOpenCycleModalBody(): React.ReactNode {
        return (
            <div className="open-cycle-modal__body">
                <p>Opening the cycle will:</p>
                <ul>
                    <li>
                        <i className="icon-check" />
                        Send an email invitation to login
                    </li>
                    <li>
                        <i className="icon-check" />
                        Allow managers to make team decisions
                    </li>
                    <li>
                        <i className="icon-check" />
                        Cannot be cancelled
                    </li>
                </ul>
            </div>
        );
    }

    private _closeOpenCycleModal(): void {
        this.props.closeModal();
    }

    private _cancelOpenCycleModal(): void {
        this._closeOpenCycleModal();
    }

    private _notifyManagersClick(): void {
        this._closeOpenCycleModal();
        this.props.onNotifyManagersClick();
    }
}

export default OpenCycleConfirmationModal;